// i18n: teksten komen uit window.KL_I18N (gevuld door snippets/keukenlab-modal-i18n.liquid).
// Staat die er niet, dan blijven de Nederlandse teksten hieronder staan.
function klT(key, fallback) {
  var d = window.KL_I18N || {};
  return (d[key] === undefined || d[key] === null || d[key] === '') ? fallback : d[key];
}
/* Fornello Keukenlab — interactivity (CLEAN theme port)
 * - Video tab switcher (Tailwind: toggles `hidden` on panels + active classes on buttons)
 * - Gated download modal (Klaviyo gating) — modal markup is Tailwind, built in JS
 */
(function () {
  // ===== Config (alleen Klaviyo public key + lead-list ID nodig) =====
  var KLAVIYO_PUBLIC_KEY = 'UBKDPT';
  var KEUKENLAB_LIST_ID = 'YrtDwh';

  // Active/inactive Tailwind class sets for the phase tab buttons.
  var BTN_ACTIVE = ['border-terracotta', 'bg-terracotta', 'text-offwhite'];
  var BTN_INACTIVE = ['border-beige', 'bg-white', 'text-taupe-donker', 'hover:border-terracotta/50'];
  var PILL_ACTIVE = ['bg-offwhite/25', 'text-offwhite'];
  var PILL_INACTIVE = ['bg-beige-licht', 'text-taupe'];

  function setBtnState(btn, active) {
    BTN_ACTIVE.forEach(function (c) { btn.classList.toggle(c, active); });
    BTN_INACTIVE.forEach(function (c) { btn.classList.toggle(c, !active); });
    var pill = btn.querySelector('span');
    if (pill) {
      PILL_ACTIVE.forEach(function (c) { pill.classList.toggle(c, active); });
      PILL_INACTIVE.forEach(function (c) { pill.classList.toggle(c, !active); });
    }
    btn.setAttribute('aria-selected', active ? 'true' : 'false');
  }

  // ===== 1. Video tab switcher =====
  document.querySelectorAll('[data-kl-tabs]').forEach(function (tabsEl) {
    var section = tabsEl.closest('section') || tabsEl.parentElement;
    var btns = tabsEl.querySelectorAll('.kl-tab-btn');
    var panels = section.querySelectorAll('.kl-tab-panel');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tk = btn.dataset.klTab;
        btns.forEach(function (b) { setBtnState(b, b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('hidden', p.dataset.klPanel !== tk);
        });
      });
    });
  });

  // ===== 2. Klaviyo gating modal =====
  window._learnq = window._learnq || [];

  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'kl-gate fixed inset-0 z-[100] hidden items-center justify-center p-4 font-sans';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = ''
      + '<div class="absolute inset-0 bg-taupe-donker/60 backdrop-blur-sm" data-kl-close></div>'
      + '<div class="relative w-full max-w-md rounded-[1.75rem] bg-offwhite border border-beige shadow-2xl shadow-taupe-donker/30 p-7 sm:p-9" role="document">'
      + '  <button type="button" aria-label="Sluiten" data-kl-close class="absolute top-4 right-4 inline-flex h-9 w-9 items-center justify-center rounded-full bg-beige-licht text-taupe-donker hover:bg-beige text-xl leading-none">&times;</button>'
      + '  <div data-kl-form-state>'
      + '    <p class="text-terracotta font-semibold text-[13px] uppercase tracking-[0.18em] mb-2">'+klT('eyebrow','Gratis download')+'</p>'
      + '    <h3 class="font-display text-[1.5rem] font-bold text-taupe-donker mb-2" data-kl-title>'+klT('title','Hier krijg je je download')+'</h3>'
      + '    <p class="text-taupe text-[14.5px] leading-relaxed mb-5">'+klT('intro','Vul je naam en e-mail in. We sturen de PDF direct naar je inbox, en openen \'m nu meteen.')+'</p>'
      + '    <form class="kl-gate__form space-y-3" novalidate>'
      + '      <div>'
      + '        <label class="block text-[13px] font-semibold text-taupe-donker mb-1" for="kl-gate-name">'+klT('label_name','Voornaam')+'</label>'
      + '        <input type="text" id="kl-gate-name" name="name" autocomplete="given-name" required placeholder="'+klT('placeholder_name','Bv. Steije')+'" class="w-full rounded-xl border border-beige bg-white px-4 py-3 text-[15px] text-taupe-donker placeholder:text-taupe/60 focus:outline-none focus:ring-2 focus:ring-terracotta/40">'
      + '      </div>'
      + '      <div>'
      + '        <label class="block text-[13px] font-semibold text-taupe-donker mb-1" for="kl-gate-email">'+klT('label_email','E-mail')+'</label>'
      + '        <input type="email" id="kl-gate-email" name="email" autocomplete="email" required placeholder="'+klT('placeholder_email','naam@email.nl')+'" class="w-full rounded-xl border border-beige bg-white px-4 py-3 text-[15px] text-taupe-donker placeholder:text-taupe/60 focus:outline-none focus:ring-2 focus:ring-terracotta/40">'
      + '      </div>'
      + '      <div class="text-[13px] text-terracotta-donker font-medium" role="alert" data-kl-error hidden></div>'
      + '      <button type="submit" data-kl-submit class="w-full rounded-full bg-terracotta hover:bg-terracotta-donker text-offwhite font-semibold px-6 py-3.5 text-[15px] transition-colors">'+klT('submit','Stuur de PDF')+'</button>'
      + '      <p class="text-[12px] text-taupe leading-relaxed">'+klT('consent','Door te versturen krijg je deze download en af en toe brood-tips van Fornello. Uitschrijven kan altijd.')+'</p>'
      + '    </form>'
      + '  </div>'
      + '  <div data-kl-success-state hidden class="text-center">'
      + '    <div class="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-terracotta text-offwhite text-2xl" aria-hidden="true">&check;</div>'
      + '    <h3 class="font-display text-[1.5rem] font-bold text-taupe-donker mb-2">'+klT('success_title','Top, je PDF staat klaar')+'</h3>'
      + '    <p class="text-taupe text-[14.5px] leading-relaxed mb-6" data-kl-success-text>De download opent in een nieuw tabblad. We sturen \'m ook naar je mailbox.</p>'
      + '    <a href="#" target="_blank" rel="noopener" data-kl-download-btn class="block w-full rounded-full bg-terracotta hover:bg-terracotta-donker text-offwhite font-semibold px-6 py-3.5 text-[15px] transition-colors mb-3">Download opnieuw</a>'
      + '    <button type="button" data-kl-close class="text-[14px] font-semibold text-taupe-donker hover:text-terracotta">Verder kijken</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-kl-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) closeModal();
    });

    var form = modal.querySelector('.kl-gate__form');
    form.addEventListener('submit', onSubmit);
    return modal;
  }

  function openModal(ctx) {
    ensureModal();
    modal._ctx = ctx;
    modal.querySelector('[data-kl-form-state]').hidden = false;
    modal.querySelector('[data-kl-success-state]').hidden = true;
    var errBox = modal.querySelector('[data-kl-error]');
    errBox.hidden = true;
    errBox.textContent = '';
    var submitBtn = modal.querySelector('[data-kl-submit]');
    submitBtn.disabled = false;
    submitBtn.textContent = klT('submit', 'Stuur de PDF');
    var title = modal.querySelector('[data-kl-title]');
    if (ctx.downloadTitle) title.textContent = ctx.downloadTitle;
    document.body.style.overflow = 'hidden';
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    setTimeout(function () {
      var emailInput = modal.querySelector('#kl-gate-email');
      var nameInput = modal.querySelector('#kl-gate-name');
      (nameInput.value ? emailInput : nameInput).focus();
    }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.body.style.overflow = '';
    if (modal._timeoutId) { clearTimeout(modal._timeoutId); modal._timeoutId = null; }
    if (modal._xhr) { try { modal._xhr.abort(); } catch (e) {} modal._xhr = null; }
    isSubmitting = false;
  }

  function showError(msg) {
    var errBox = modal.querySelector('[data-kl-error]');
    errBox.textContent = msg;
    errBox.hidden = false;
    var submitBtn = modal.querySelector('[data-kl-submit]');
    submitBtn.disabled = false;
    submitBtn.textContent = klT('submit', 'Stuur de PDF');
  }

  var isSubmitting = false;

  function onSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return;
    var ctx = modal._ctx || {};
    var firstName = (modal.querySelector('#kl-gate-name').value || '').trim();
    var email = (modal.querySelector('#kl-gate-email').value || '').trim();
    if (!firstName) { showError(klT('err_name', 'Vul je voornaam in.')); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError(klT('err_email', 'Vul een geldig e-mailadres in.')); return; }

    isSubmitting = true;
    var submitBtn = modal.querySelector('[data-kl-submit]');
    submitBtn.disabled = true;
    submitBtn.textContent = klT('sending', 'Een momentje...');

    // KRITISCH: Open PDF NU binnen user-gesture (iOS/Safari blokkeert popups
    // na een setTimeout).
    var pdfWindow = null;
    try {
      pdfWindow = window.open(ctx.pdfUrl, '_blank', 'noopener');
    } catch (err) { /* swallow */ }

    var today = new Date().toISOString().slice(0, 10);
    var profileProps = {
      keukenlab_lead: true,
      keukenlab_last_product: ctx.product,
      keukenlab_last_download: ctx.product + '_' + ctx.downloadType,
      keukenlab_last_date: today
    };

    // 1. identify
    window._learnq.push(['identify', Object.assign({
      '$email': email,
      '$first_name': firstName
    }, profileProps)]);

    // 2. track event -> flow trigger
    window._learnq.push(['track', 'Keukenlab Download Requested', {
      product: ctx.product,
      product_label: ctx.productLabel,
      download_type: ctx.downloadType,
      download_title: ctx.downloadTitle,
      pdf_url: ctx.pdfUrl,
      source: 'keukenlab'
    }]);

    // 2a. Multicooker legacy metric
    if (ctx.product === 'multicooker') {
      window._learnq.push(['track', 'Multicooker Lead Identified', {
        product: 'multicooker',
        source: 'keukenlab',
        download_type: ctx.downloadType
      }]);
    }

    // 3. subscribe via kmail-lists XHR (CORS-safe)
    modal._timeoutId = setTimeout(function () {
      var fd = new URLSearchParams();
      fd.append('g', KEUKENLAB_LIST_ID);
      fd.append('email', email);
      fd.append('$first_name', firstName);
      fd.append('$consent', 'email');
      fd.append('$source', 'keukenlab-' + ctx.product);

      var xhr = new XMLHttpRequest();
      modal._xhr = xhr;
      xhr.open('POST', 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        var ok = xhr.status >= 200 && xhr.status < 300;
        try {
          var body = JSON.parse(xhr.responseText);
          if (ok && body && body.success === false) ok = false;
        } catch (e) { /* non-JSON ok */ }
        isSubmitting = false;
        if (ok) {
          showSuccess(ctx, pdfWindow, false);
        } else {
          showSuccess(ctx, pdfWindow, true);
          console.warn('Keukenlab subscribe non-2xx', xhr.status, xhr.responseText && xhr.responseText.slice(0, 200));
        }
      };
      xhr.onerror = function () {
        isSubmitting = false;
        showSuccess(ctx, pdfWindow, true);
        console.error('Keukenlab subscribe network error');
      };
      xhr.send(fd.toString());
      modal._timeoutId = null;
    }, 3500);
  }

  function showSuccess(ctx, pdfWindow, subscribeFallback) {
    var btn = modal.querySelector('[data-kl-download-btn]');
    var txt = modal.querySelector('[data-kl-success-text]');
    btn.href = ctx.pdfUrl;
    var popupOK = !!pdfWindow;
    if (!popupOK) {
      txt.textContent = klT('success_text_tap', 'Tik op de knop om je PDF te openen. We sturen \'m ook naar je mailbox.');
      btn.textContent = klT('open_pdf', 'Open mijn PDF');
    } else if (subscribeFallback) {
      txt.textContent = klT('success_text_mail', 'De download opent in een nieuw tabblad. Mocht de mail niet aankomen, mail support@fornello.eu.');
      btn.textContent = klT('download_again', 'Download opnieuw');
    } else {
      txt.textContent = klT('success_text', 'De download opent in een nieuw tabblad. We sturen \'m ook naar je mailbox.');
      btn.textContent = klT('download_again', 'Download opnieuw');
    }
    modal.querySelector('[data-kl-form-state]').hidden = true;
    modal.querySelector('[data-kl-success-state]').hidden = false;
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'keukenlab_download',
        product: ctx.product,
        download_type: ctx.downloadType
      });
    }
  }

  // ===== 3. Bind clicks =====
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.kl-download');
    if (!el) return;
    var gated = el.dataset.gated === 'true';
    if (!gated) return; // open direct in nieuw tabblad
    e.preventDefault();
    var ctx = {
      product: el.dataset.productKey || (el.dataset.product || '').toLowerCase().split(' ')[0],
      productLabel: el.dataset.product || '',
      downloadType: el.dataset.type || '',
      downloadTitle: (el.querySelector('h4') && el.querySelector('h4').textContent || '').trim(),
      pdfUrl: el.getAttribute('href')
    };
    openModal(ctx);
  });
})();
